import { Injectable } from '@angular/core';
import { ProductConfigurationBaseService } from '@df/module-product-configuration/model/base/product-configuration-base.service';
import type { IAddToBasketData } from '@df/session/api/basket/basket';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class ProductConfigurationBaseServiceDecorator extends ProductConfigurationBaseService {
    additionalProducts$ = new BehaviorSubject<IAddToBasketData[]>([]);
}
